<template>
  <label class="access-content">
    <input
      type="checkbox"
      name="search_scope"
      id="search_scope"
      value="openAccess"
      v-bind:checked="openAccess"
      v-on:change="updateOpenAccess(queryObj, $event)"
    />
    <span>Search for free use content only</span>
  </label>
</template>

<script setup>
import { useFacets } from "lit-discovery/vue/composables/useFacets";

const props = defineProps({
  openAccess: Boolean,
});

const { toggleFilterAction } = useFacets();

const updateOpenAccess = () => {
  toggleFilterAction("access.type", "open");
};
</script>

<script>
// TODO: double check that the exta queryObj pieces here aren't needed anymore. I don't think they are.
//   export default {
//     model: {
//       prop: 'openAccess',
//       event: 'change'
//     },
//     props:[
//       "queryObj",
//       'openAccess'
//     ],
//     methods: {
//       updateOpenAccess: function (queryObj, $event){
//         let $self = this;
//         $self.$facetFilters.toggleFilter('access.type', 'open');
//         let termsStr = $self.$facetFilters.makeTermsStr();
//         queryObj.term = termsStr['termStr'];
//         queryObj.nested_term = termsStr['nestedTermStr'];
//         $self.$emit('change', $event.target.openAccess)
//       }
//     }
//   }
//
</script>
